class OfferMiniCountdown extends HTMLElement {
  connectedCallback() {
    this.endTime = new Date(this.dataset.end).getTime();

    if (isNaN(this.endTime)) {
      this.remove();
      return;
    }

    this.timerEl = this.querySelector('.offer-mini-countdown__timer');

    this.tick();
    this.interval = setInterval(this.tick.bind(this), 1000);
  }

  disconnectedCallback() {
    if (this.interval) clearInterval(this.interval);
  }

  tick() {
    const diff = this.endTime - Date.now();

    if (diff <= 0) {
      clearInterval(this.interval);
      this.remove();
      return;
    }

    const day = 1000 * 60 * 60 * 24;
    const hour = 1000 * 60 * 60;
    const minute = 1000 * 60;

    const days = Math.floor(diff / day);
    const hours = Math.floor((diff % day) / hour);
    const minutes = Math.floor((diff % hour) / minute);
    const seconds = Math.floor((diff % minute) / 1000);

    const pad = (n) => (n < 10 ? '0' + n : String(n));

    this.timerEl.innerHTML = [
      ['DAYS', days],
      ['HRS', hours],
      ['MIN', minutes],
      ['SEC', seconds]
    ]
      .map(
        ([label, value]) =>
          `<span class="offer-mini-countdown__item"><span class="offer-mini-countdown__value">${pad(value)}</span><span class="offer-mini-countdown__label">${label}</span></span>`
      )
      .join('');
  }
}

customElements.define('offer-mini-countdown', OfferMiniCountdown);
